import ErrorFooter from '../../../assets/Modals/ErrorFooter';
import SuccessFooter from '../../../assets/Modals/SuccessFooter';
import Button from '../../Button';
import { Container, LeftContainer, Text } from './styles';

type PostModalProps = {
  success: boolean;
  text: string;
  open: any;
  onClose: any;
};

export default function FooterModal({ success, text, open, onClose }: PostModalProps) {
  return (
    <Container>
      <LeftContainer>
        {success ? <SuccessFooter /> : <ErrorFooter />}
        <Text>{text}</Text>
      </LeftContainer>
      <Button width={120} height={42} text='Fechar' theme='dark' />
    </Container>
  );
}